import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fold",
  "use": "fold-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"fold\"><defs><style>#fold .cls-1{fill-rule:evenodd}</style></defs><path class=\"cls-1\" d=\"M1 0h18a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm0 14h18a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zM.42 5.01h9.16a1.4 1.4 0 0 1 0 2H.42a1.4 1.4 0 0 1 0-2zm0 3.979h9.16a1.4 1.4 0 0 1 0 2H.42a1.4 1.4 0 0 1 0-1.999zM15.5 11L12 5h7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fold.svg
// module id = UWrL
// module chunks = 6